export default {
  DASHBOARD: {
    TEACHER: {
      SUBTITLE: "Total",
    },
    STAFF: {
      SUBTITLE: "Total",
    },
  },
};
